import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isAuthPath, isSafeReturnPath, rememberReturnPath } from '@/utils/returnPath';

/**
 * Records the page the visitor is on so sign-in can send them back to it (see
 * utils/returnPath.ts). Pages reached *from* a sign-in page (Terms and Privacy
 * are linked there) are not recorded: the visitor is wandering from the login
 * screen, not starting from those pages.
 */
export function ReturnPathTracker() {
  const { pathname, search } = useLocation();
  const previous = useRef<string | null>(null);

  useEffect(() => {
    const cameFromAuthPage = previous.current != null && isAuthPath(previous.current);
    const path = pathname + search;
    if (!cameFromAuthPage && !isAuthPath(pathname) && isSafeReturnPath(path)) rememberReturnPath(path);
    previous.current = pathname;
  }, [pathname, search]);

  return null;
}
